import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/BrandGeometry";
import { WHY, ARCH_IMAGE } from "@/lib/content";

export default function WhyAmanah() {
  return (
    <section id="why" className="border-b border-line bg-cream">
      <div className="mx-auto max-w-7xl px-6 py-24 sm:px-10 sm:py-32 lg:px-16">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          {/* Deliberate, navy-treated architectural frame */}
          <div className="lg:col-span-5">
            <Reveal>
              <figure className="relative aspect-[4/5] overflow-hidden">
                <img
                  src={ARCH_IMAGE}
                  alt="Considered, structured architecture — a visual note on Amanah's disciplined approach"
                  className="h-full w-full object-cover grayscale"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-navy/60 mix-blend-multiply" aria-hidden="true" />
                <div className="absolute inset-0 ring-1 ring-inset ring-navy/10" aria-hidden="true" />
                <figcaption className="absolute bottom-5 left-5 right-5 font-display text-lg text-white">
                  Structure, discipline and clear lines of accountability.
                </figcaption>
              </figure>
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:pl-4">
            <Reveal>
              <Eyebrow>Why Amanah</Eyebrow>
              <h2 className="mt-6 font-display text-4xl font-medium leading-tight tracking-tight text-navy sm:text-5xl">
                Why charities choose Amanah
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <ul className="mt-10 divide-y divide-line border-y border-line">
                {WHY.map((w, i) => (
                  <li key={w} className="flex items-baseline gap-5 py-4">
                    <span className="font-display text-sm font-medium text-brand-green">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="text-lg font-medium text-navy">{w}</span>
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
